<template>
  <v-form ref="form" v-model="validacion" lazy-validation
    ><!--ver para que el lazy validation xD -->
    <v-layout>
      <v-flex>
        <v-select
          v-model="tipoCentroValue"
          :items="tipoCentroSelect"
          item-text="nombre"
          item-value="id"
          :error-messages="rolSelectErrors"
          label="Tipo Centro"
          :box="
            tipeView == 'crear'
              ? false
              : isDisabled || disableonmodifica || vistaconsulta
          "
          :readonly="
            tipeView == 'crear'
              ? false
              : isDisabled || disableonmodifica || vistaconsulta
          "
          @input="$v.tipoCentroValue.$touch()"
          @blur="tipeView == 'crear' ? $v.tipoCentroValue.$touch() : null"
        ></v-select>
        <v-text-field
          v-model="codCentro"
          :error-messages="nombreErrors"
          label="Cod Centro"
          :box="tipeView == 'crear' ? false : isDisabled || vistaconsulta"
          :readonly="tipeView == 'crear' ? false : isDisabled || vistaconsulta"
          @input="$v.nombre.$touch()"
          @blur="tipeView == 'crear' ? $v.nombre.$touch() : null"
        ></v-text-field>
        <v-select
          v-model="regionValue"
          :items="regionSelect"
          item-text="nombre"
          item-value="id"
          :error-messages="rolSelectErrors"
          label="Region"
          :box="
            tipeView == 'crear'
              ? false
              : isDisabled || disableonmodifica || vistaconsulta
          "
          :readonly="
            tipeView == 'crear'
              ? false
              : isDisabled || disableonmodifica || vistaconsulta
          "
          @input="$v.rolUsuarioValue.$touch()"
          @blur="tipeView == 'crear' ? $v.regionValue.$touch() : null"
        ></v-select>
        <v-select
          v-model="tipoUsuarioValue"
          :items="tipoUsuarioSelect"
          item-text="nombre"
          item-value="nombre"
          :error-messages="tipoSelectErrors"
          label="Comuna"
          :box="
            tipeView == 'crear'
              ? false
              : isDisabled || disableonmodifica || vistaconsulta
          "
          :readonly="
            tipeView == 'crear'
              ? false
              : isDisabled || disableonmodifica || vistaconsulta
          "
          @input="$v.tipoUsuarioValue.$touch()"
          @blur="tipeView == 'crear' ? $v.tipoUsuarioValue.$touch() : null"
        ></v-select>
      </v-flex>
      <v-flex xs12 md1></v-flex>
      <v-flex>
        <v-sheet>
          <v-switch
            v-model="switch1"
            color="indigo darken-3"
            inset
            :label="`Movil: ${switch1.toString()}`"
          ></v-switch>
          <v-switch
            v-model="switch2"
            inset
            :label="`Excepcional: ${switch2.toString()}`"
          ></v-switch>
        </v-sheet>
        <v-text-field
          v-model="nombre"
          :error-messages="nombreErrors"
          label="Metros Cuadrados"
          :box="tipeView == 'crear' ? false : isDisabled || vistaconsulta"
          :readonly="tipeView == 'crear' ? false : isDisabled || vistaconsulta"
          @input="$v.nombre.$touch()"
          @blur="tipeView == 'crear' ? $v.nombre.$touch() : null"
        ></v-text-field>
        <v-text-field
          v-model="nombre"
          :error-messages="nombreErrors"
          label="Metros Cubicos"
          :box="tipeView == 'crear' ? false : isDisabled || vistaconsulta"
          :readonly="tipeView == 'crear' ? false : isDisabled || vistaconsulta"
          @input="$v.nombre.$touch()"
          @blur="tipeView == 'crear' ? $v.nombre.$touch() : null"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <v-text-field
          v-model="apellido"
          :error-messages="apellidoErrors"
          label="Direccion"
          :box="tipeView == 'crear' ? false : isDisabled || vistaconsulta"
          :readonly="tipeView == 'crear' ? false : isDisabled || vistaconsulta"
          @input="$v.apellido.$touch()"
          @blur="tipeView == 'crear' ? $v.apellido.$touch() : null"
        ></v-text-field>
        <v-text-field
          v-model="apellido"
          :error-messages="apellidoErrors"
          label="Alias Centro"
          :box="tipeView == 'crear' ? false : isDisabled || vistaconsulta"
          :readonly="tipeView == 'crear' ? false : isDisabled || vistaconsulta"
          @input="$v.apellido.$touch()"
          @blur="tipeView == 'crear' ? $v.apellido.$touch() : null"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </v-form>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import axios from "axios";
import { misRoles } from "@/mixins/roles.js";

export default {
  name: "usuario-data",
  components: {},
  mixins: [misRoles, validationMixin],
  props: {},
  data() {
    return {
      tipeView: "",
      username: "",
      validacion: false,
      nombre: "",
      apellido: "",
      tipoUsuarioValue: "",
      tipoUsuarioSelect: [],
      contratoSelect: [],
      rolUsuarioSelect: [],
      resp: [],
      body: [],
      usuario: "",
      rolUsuarioValue: "",
      exist: "",
      contratoValue: "",
      tipoUsuario: "",
      bttnDisabled: true,
      contratoId: "",
      id: "",
      rolesUsuario: [],
      rolFiltro: "",
      loading: false,
      switch1: true,
      switch2: false,
    };
  },

  validations: {
    apellido: { required }, //maxLength: maxLength(10)
    nombre: { required },
    username: { required, email },
    tipoUsuarioValue: { required },
    rolUsuarioValue: { required },
  },

  created() {
    this.contratoId = this.$store.getters.contratoStored;
    this.tipoUsuario = this.$route.params.tipeUser;
    this.username = this.$route.params.username;
    this.id = this.$route.params.id;
    this.tipeView = this.$route.params.tipeView;
    if (!this.tipeView || this.tipeView == null || this.tipeView == "") {
      this.tipeView = "crear";
    }
    if (this.tipeView == "crear") {
      this.tipoCentroSelect = [this.$store.getters.subTabSelectedStored];
      this.tipoCentroValue = this.$store.getters.subTabSelectedStored;
    }
  },
  mounted() {
    if (this.tipeView == "consulta" || this.tipeView == "modifica") {
      this.loadData();
    }
    if (this.tipeView == "crear") {
      this.loadRoldata();
      this.loadSelectTipoUsuario();
    }
  },
  computed: {
    nombreErrors() {
      const errors = [];
      if (!this.$v.nombre.$dirty) return errors;
      !this.$v.nombre.required && errors.push("Nombre is required.");
      return errors;
    },
    apellidoErrors() {
      const errors = [];
      if (!this.$v.apellido.$dirty) return errors;

      !this.$v.apellido.required && errors.push("Apellido is required.");
      return errors;
    },
    usernameErrors() {
      const errors = [];
      if (!this.$v.username.$dirty) return errors;
      !this.$v.username.email && errors.push("Must be valid e-mail");
      !this.$v.username.required && errors.push("E-mail is required");
      if (this.exist) {
        errors.push("Usuario ya existe en el contrato");
      }
      return errors;
    },

    tipoSelectErrors() {
      const errors = [];
      if (!this.$v.tipoUsuarioValue.$dirty) return errors;
      !this.$v.tipoUsuarioValue.required && errors.push("Item is required");
      return errors;
    },
    //VALIDACIONES QUE SE USAN CUANDO SE CREA USUARIO DESDE CONFIGURACION
    //   contratoSelectErrors() {
    //   const errors = [];
    //   if (!this.$v.contratoValue.$dirty) return errors;
    //   !this.$v.contratoValue.required && errors.push("Item is required");
    //   return errors;
    // },
    rolSelectErrors() {
      const errors = [];
      if (!this.$v.rolUsuarioValue.$dirty) return errors;
      !this.$v.rolUsuarioValue.required && errors.push("Item is required");
      return errors;
    },

    isDisabled() {
      if (this.tipeView != "modifica" || this.tipeView != "crear") {
        return false;
      } else {
        return this.usuario != null && this.usuario != "" ? true : false;
      }
    },
    isDisabledRol() {
      if (this.tipeView == "consulta" || this.tipeView == "modificar") {
        return true;
      }
    },
    disableonmodifica() {
      if (this.tipeView == "modifica") {
        return true;
      }
    },
    vistaconsulta() {
      if (this.tipeView == "consulta") {
        return true;
      }
    },
  },
  methods: {
    checkUsername() {
      let e = false;
      if (
        this.username !== undefined &&
        this.username != null &&
        this.username != "" &&
        this.contratoId !== undefined &&
        this.contratoId != null &&
        this.contratoId != ""
      ) {
        axios
          .get("/user/" + this.username + "/contrato/" + this.contratoId)
          .then((response) => {
            if (!response.data.code || response.data.code === "undefined") {
              this.usuario = response.data;
              this.nombre = this.usuario.nombre;
              this.apellido = this.usuario.apellido;
              if (response.data.lstUsuContratoRol.length > 0) {
                this.hasContrato(response.data.lstUsuContratoRol);
              }
            }
          })
          .catch((error) => {
            this.exist = false;
            console.log(error);
            this.loading = false;
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          });
      } else {
        this.bttn = true;
      }
      // console.log(JSON.stringify(this.usuario));
      this.usernameErrors;
    },

    async loadTipoCentroData() {
      var that = this;
      return await axios
        .get("/centro/tipos")
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    loadRoldata() {
      //despues buscar que solo traiga los roles del tipo seleccionado
      axios
        .get("/roles/tipo/" + this.tipoUsuario + "/" + this.contratoId)
        .then((response) => {
          this.setRolSelect(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setRolSelect(data) {
      let roles = [];
      data.forEach((r) => {
        roles.push({ id: r.id, nombre: r.nombre, codigo: r.codigoRol });
      });
      this.rolUsuarioValue = roles;
      this.rolUsuarioSelect = this.rolUsuarioValue;
    },
    async loadContratoDato() {
      return await axios
        .get("/user/username/" + this.contratoId)
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    loadSelectTipoUsuario(tip) {
      if (this.tipeView == "crear") {
        this.tipoUsuarioSelect = [this.tipoUsuario];
        this.tipoUsuarioValue = this.tipoUsuario;
      }
    },

    async loadData() {
      this.usuario = await this.loadUsuarioData();
      let rolesUsuario = this.getRol(this.usuario.lstUsuContratoRol);
      let rolData = this.getUsuRolContrato(rolesUsuario);
      this.rolUsuarioSelect = [rolData[0].nombre];
      this.rolUsuarioValue = rolData[0].nombre;
      this.nombre = this.usuario.nombre;
      this.id = this.usuario.id;
      this.apellido = this.usuario.apellido;
      this.tipoUsuarioSelect = [this.usuario.tipo];
      this.tipoUsuarioValue = this.usuario.tipo;
    },

    back() {
      setTimeout(() => {
        // this.$store.state.route.from.fullPath;
        this.$router.go(-1);
      }, 1000);
    },
    loadContratos() {},

    save() {
      if (this.tipeView == "crear") {
        this.saveUser();
        this.loading = true;
      } else {
        this.editUser();
        this.loading = true;
      }
    },

    editUser() {
      this.loading = true;
      /// se debe validar el tipeo de los datos
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idUserLogged = this.$store.getters.userLogged.id;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        nombre: this.nombre,
        apellido: this.apellido,
        subProceso: subProceso,
        idContrato: idContrato,
      };
      axios
        .put("/user/" + this.id, this.body)
        .then((response) => {
          this.resp = response.data;
          this.loading = false;
          window.getApp.$emit("APP_UPDATE");
          this.back();
        })
        .catch(function (error) {
          console.log(error);
          window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          this.loading = false;
        });
    },

    //this is a map
    hasContrato(mapContrato) {
      for (const prop in mapContrato[0]) {
        if (mapContrato[0].hasOwnProperty(prop)) {
          this.exist = true;
        }
      }
    },
  },
};
</script>
